// directives/preload.ts
import { html, nothing } from "lit";
import { directive, Directive } from "lit/directive.js";
import { styleMap } from "lit/directives/style-map.js";
var hasLoaded = /* @__PURE__ */ new WeakMap();
var PreloadDirective = class extends Directive {
  constructor(partInfo) {
    super(partInfo);
    this._startNode = partInfo.parentNode;
  }
  render(pages, currentPage, eager) {
    const normalizedEager = eager === true ? Object.keys(pages) : eager;
    if (!hasLoaded.has(this._startNode))
      hasLoaded.set(this._startNode, /* @__PURE__ */ new Map());
    const cache = hasLoaded.get(this._startNode);
    return html`
      <div style=${styleMap({ height: "100%", width: "100%", overflow: "hidden", position: "relative" })}>
        ${Object.entries(pages).map(([key, value]) => {
      const shouldKnowValue = normalizedEager?.includes(currentPage) || currentPage === key;
      if (shouldKnowValue)
        cache.set(key, value());
      return html`<div
            ?selected=${key === currentPage}
            style=${styleMap({
        position: "absolute",
        height: "100%",
        width: "100%",
        transition: "opacity .12s ease",
        ...key === currentPage ? { opacity: "1", pointerEvents: "all", zIndex: "unset" } : { opacity: "0", pointerEvents: "none", zIndex: "-1" }
      })}
          >
            ${shouldKnowValue || cache.has(key) ? cache.get(key) : nothing}
          </div>`;
    })}
      </div>
    `;
  }
};
var preload = directive(PreloadDirective);
export {
  preload
};
